<template>    
    <footer class="text-center py-3">
        <p class="mb-0">&copy; 2025 Poligrama</p>
    </footer>
</template>